// src/pages/DirectPage/ChatHeader.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { directPageStyles } from './styles';

// User Icon SVG
const UserIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);

// Back Arrow Icon SVG
const BackIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="19" y1="12" x2="5" y2="12" />
    <polyline points="12 19 5 12 12 5" />
  </svg>
);

const ChatHeader = ({ seller }) => {
  const navigate = useNavigate();

  return (
    <div style={directPageStyles.chatHeader}>
      <button 
        onClick={() => navigate('/direct')} 
        style={directPageStyles.backButton}
        aria-label="Back to messages"
      >
        <BackIcon />
      </button>
      
      <div style={directPageStyles.avatarWrapper}>
        {seller?.profilePic ? (
          <img 
            src={seller.profilePic} 
            alt="User avatar" 
            style={directPageStyles.sellerAvatar}
          />
        ) : (
          <div style={directPageStyles.avatarPlaceholder}>
            <UserIcon />
          </div>
        )}
      </div>
      
      <div style={directPageStyles.sellerInfo}>
        <h2 style={directPageStyles.sellerName}>
          {seller?.name || 'Unknown User'}
        </h2>
        <p style={directPageStyles.sellerStatus}>Active on Redbird Markets</p>
      </div>
    </div>
  );
};

export default ChatHeader;